import { Injectable } from '@angular/core'
import { SpeechRecognitionProvider } from './speech-recognition-provider'
import { WebSpeechProvider } from './web-speech-provider'

@Injectable({ providedIn: 'root' })
export class SpeechRecognitionService {
    private providers: SpeechRecognitionProvider[] = [new WebSpeechProvider()]
    private activeProvider: SpeechRecognitionProvider | null = null
    private activeForceStopCallback: (() => void) | null = null

    getProviders(): SpeechRecognitionProvider[] {
        return this.providers
    }

    getProvider(name: string): SpeechRecognitionProvider | undefined {
        return this.providers.find(p => p.name === name)
    }

    createProvider(): SpeechRecognitionProvider {
        return new WebSpeechProvider()
    }

    registerActive(provider: SpeechRecognitionProvider, onForceStopped: () => void): void {
        if (this.activeProvider && this.activeProvider !== provider) {
            this.activeProvider.stop()
            this.activeForceStopCallback?.()
        }

        this.activeProvider = provider
        this.activeForceStopCallback = onForceStopped
    }

    unregisterActive(provider: SpeechRecognitionProvider): void {
        if (this.activeProvider === provider) {
            this.activeProvider = null
            this.activeForceStopCallback = null
        }
    }
}
